import FpuiPackageDetail from './FpuiPackageDetail.vue'

export default FpuiPackageDetail
